export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILED = "AUTH_FAILED";
export const UPDATE_BAG = "UPDATE_BAG";
export const RESET_BAG = "RESET_BAG";
export const UPDATE_ADDRESSES = "UPDATE_ADDRESSES";
export const LOADING_TRUE = "LOADING_TRUE";
export const LOADING_FALSE = "LOADING_FALSE";
export const GET_USER_INFO = "GET_USER_INFO";
export const GET_USER_GROUP = "GET_USER_GROUP";
